<template>
    <div class="grid-skeleton w-full">
        <div class="mb-2" :class="showBgHeader ? 'background-header' : ''">
            <div class="d-flex align-items-center" :class="titleCenter ? 'justify-content-center' : 'justify-content-between'">
                <h2 class="section-title"></h2>
                <div class="view-all" v-if="!titleCenter"></div>
            </div>
        </div>

        <div class="grid-skeleton-inner products-grid-skeleton-inner" v-if="!isShowSteketonMd && !isShowSteketonSm">
          <ProductCardSkeleton v-for="index in this.quantity || 6" :key="index"></ProductCardSkeleton>
        </div>

        <div class="grid-skeleton-inner products-grid-skeleton-inner" v-if="isShowSteketonMd">
          <ProductCardSkeleton v-for="index in 4" :key="index"></ProductCardSkeleton>
        </div>

        <div class="grid-skeleton-inner products-grid-skeleton-inner" v-if="isShowSteketonSm">
          <ProductCardSkeleton v-for="index in 2" :key="index"></ProductCardSkeleton>
        </div>

        <BannerGridSkeleton v-if="showBanner"></BannerGridSkeleton>

        <div class="product-categories mt-2 d-flex align-items-center" v-if="showSubCategories || false">
            <div class="category-item-skeleton" v-for="index in 5"></div>
        </div>

        <div class="align-items-center justify-content-center mt-2 d-flex" v-if="showMore || false">
            <div class="btn-more-skeleton"></div>
        </div>
    </div>
</template>

<script>
import ProductCardSkeleton from './common/ProductCardSkeleton.vue';
import BannerGridSkeleton from './common/BannerGridSkeleton.vue';

export default {
    data() {
        return {
            isShowSteketonMd: false,
            isShowSteketonSm: false,
        };
    },
    components: { ProductCardSkeleton, BannerGridSkeleton },
    props: ['quantity', 'showSubCategories', 'showMore', 'showViewAll', 'titleCenter', 'showBanner', 'showBgHeader'],
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize() {
        if (parseInt(window.innerWidth) <= 576) {
          this.isShowSteketonSm = true;
          this.isShowSteketonMd = false;
        } else if (576 < parseInt(window.innerWidth) && parseInt(window.innerWidth) <= 991) {
          this.isShowSteketonSm = false;
          this.isShowSteketonMd = true;
        } else {
          this.isShowSteketonSm = false;
          this.isShowSteketonMd = false;
      }
    },
  },
};
</script>
